import {
  READ_LOGIN,
  LOAD_LOGIN,
  RESET_LOGIN
} from "types/Types";

const initialState = {
  useraccount_id: "",
  username: "",
  password: "",
  firstName: "",
  lastName1: "",
  lastName2: "",
  email: "",
  esir_username: "",
  esir_password: "",
  enabled: false,
  isAccountNonLocked: true,
  aliasuser: "",
  createdate: "",
  language: {},
  defaultStore: {},  
  defaultEmployee: {},  
  defaulttypesdi: {},
  defaultticketsformat:{},
  roles: [],
  token: "",
  authorities: []
};

export function loginReducer(state = initialState, action) {
  switch (action.type) {
    case READ_LOGIN:
      return state;
    case LOAD_LOGIN: {
      const {
        id,
        username,
        password,
        firstName,
        lastName1,
        lastName2,
        email,
        esir_username,
        esir_password,
        enabled,
        isAccountNonLocked,
        aliasuser,
        createdate,
        language,
        defaultStore,
        defaultEmployee,
        defaulttypesdi,
        defaultticketsformat,
        roles,
        token
      } = action.payload;
      
      return {
        ...state,
        useraccount_id: id || "",
        username: username || "",
        password: password || "",
        firstName: firstName || "",
        lastName1: lastName1 || "",
        lastName2: lastName2 || "",
        email: email || "",
        esir_username: esir_username || "",
        esir_password: esir_password || "",  
        enabled: enabled !== null ? enabled : true,
        isAccountNonLocked: isAccountNonLocked !== null ? isAccountNonLocked : true,
        aliasuser: aliasuser || "",
        createdate: createdate || "",
        language: language || {},
        defaultStore: defaultStore || {},
        defaultEmployee:defaultEmployee || {},
        defaulttypesdi: defaulttypesdi || {},
        defaultticketsformat: defaultticketsformat || {}, 
        roles: roles || [],
        token: token || ""
      };
    }
    case RESET_LOGIN:
      return initialState;
    default:
      return state;
  }
}
